"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auto = Auto;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function Auto(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "58",
    height: "14",
    viewBox: "0 0 58 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M0.928801 13L6.4948 1.109H8.94047L14.5065 13H11.403L10.3741 10.5881H5.06113L4.03227 13H0.928801ZM7.69234 4.3474L6.07314 8.20987H9.34527L7.72607 4.3474H7.69234ZM23.09 13.1855C21.3583 13.1855 20.0315 12.747 19.1094 11.8699C18.1986 10.9929 17.7432 9.68289 17.7432 7.94V1.109H20.8467V7.97373C20.8467 8.83955 21.0379 9.49173 21.4202 9.93027C21.8025 10.3688 22.3591 10.5881 23.09 10.5881C23.8096 10.5881 24.3606 10.3688 24.7429 9.93027C25.1252 9.49173 25.3164 8.83955 25.3164 7.97373V1.109H28.3692V7.94C28.3692 9.68289 27.9195 10.9929 27.0199 11.8699C26.1316 12.747 24.8216 13.1855 23.09 13.1855ZM35.9278 13V3.639H32.1497V1.109H42.8094V3.639H39.0313V13H35.9278ZM51.7088 13.1855C50.5056 13.1855 49.4487 12.9325 48.5379 12.4265C47.6383 11.9093 46.9355 11.1896 46.4295 10.2676C45.9235 9.34555 45.6705 8.27171 45.6705 7.04607C45.6705 5.80918 45.9179 4.73533 46.4127 3.82453C46.9187 2.90249 47.6271 2.18846 48.5379 1.68247C49.4487 1.17646 50.5056 0.923465 51.7088 0.923465C52.9119 0.923465 53.9633 1.17646 54.8629 1.68247C55.7737 2.18846 56.4821 2.90249 56.9881 3.82453C57.4941 4.73533 57.7471 5.80918 57.7471 7.04607C57.7471 8.27171 57.4941 9.34555 56.9881 10.2676C56.4821 11.1896 55.7737 11.9093 54.8629 12.4265C53.9633 12.9325 52.9119 13.1855 51.7088 13.1855ZM51.7088 10.5881C52.5859 10.5881 53.2718 10.2788 53.7665 9.6604C54.2725 9.03071 54.5255 8.15927 54.5255 7.04607C54.5255 5.93287 54.2781 5.06704 53.7834 4.4486C53.2886 3.83015 52.5971 3.52093 51.7088 3.52093C50.8205 3.52093 50.1289 3.83015 49.6342 4.4486C49.1394 5.06704 48.8921 5.93287 48.8921 7.04607C48.8921 8.15927 49.1394 9.03071 49.6342 9.6604C50.1289 10.2788 50.8205 10.5881 51.7088 10.5881Z",
    fill: "currentColor"
  }));
}

Auto.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Auto"
};